import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanMatch,
    Route,
    Router,
    RouterStateSnapshot,
    UrlSegment,
    UrlTree
} from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { InstanciasService } from 'src/app/app.service';

@Injectable({ providedIn: 'root'})
export class Authguard implements CanActivate, CanActivateChild, CanMatch {

    readonly mostraMenuEmit = new BehaviorSubject<boolean>(false);
    readonly menuAdmin      = new BehaviorSubject<boolean>(false);

    constructor(
        private router: Router,
        private instservice: InstanciasService) {}

    private validaAcesso(): boolean | UrlTree {
        if (!this.instservice.isLogged()) {
            this.mostraMenuEmit.next(false);
            this.instservice.removesessionStorage();
            return this.router.parseUrl('/login');
        }

        if (this.instservice.isGroupAdmin()) {
            this.menuAdmin.next(true);
        }

        this.mostraMenuEmit.next(true);
        return true;
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
            return this.validaAcesso();
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree {
            return this.validaAcesso();
    }

    canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
        return this.validaAcesso();
    }
    
    
}